module.exports = __webpack_public_path__ + "static/media/tenant-setup-reminder.76dedeb9.png";